module.exports = __webpack_public_path__ + "img/ktb.7fecd1c1.png";